import { Socket } from "socket.io-client";
import { liveRoomBody, ProfileDataInterface } from "@/types/common";
import axios from "@/utils/axios";
import { Config } from "@/utils/config";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import {
  resetLiveRoomDetails,
  setLiveRoomDetails,
} from "@/redux/reducers/LiveRoomReducer";
import { joinRoomResponseType, UserDataType } from "@/types/global";
import { getImageUrl } from "@/utils/helper";

export default function useJoinRoom() {
  const socket = useAppSelector((state) => state.LiveRoom.liveRoomSocket!);
  const dispatch = useAppDispatch();
  const joinRoom = async ({
    roomId,
    userId,
    token,
    body,
    onLive = false,
  }: {
    roomId?: string;
    userId?: string;
    token?: string;
    onLive?: boolean;
    body?: liveRoomBody;
  }): Promise<undefined | joinRoomResponseType> => {
    return new Promise(async (resolve, reject) => {
      try {
        let joinRoomId = roomId;
        // get roomId
        if (!roomId && userId && token) {
          const roomDataResp = await axios.get(
            `${Config.LIVE_ROOM_SOCKET_URL}/rooms/my-rooms?limit=20&skip=0&userId=${userId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const roomData = roomDataResp.data;
          if (
            Array.isArray(roomData) &&
            roomData.length &&
            roomData[0].id > 0
          ) {
            joinRoomId = roomData[0].id;
          } else {
            const roomData = await axios.post(
              `${Config.LIVE_ROOM_SOCKET_URL}/rooms/v2/add`,
              body,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            if (roomData.status === 201 && roomData.data.id) {
              joinRoomId = roomData?.data.id;
            }
          }
        }
        socket?.emit(
          "fe_join_room",
          { roomId: joinRoomId + "", isCameraOn: true },
          (response: {
            error?: { message: string; statusCode: number };
            message?: string;
            data: {
              zegoRtcToken: string;
              room: {
                id: number;
                announcement: string;
                allowChat: boolean;
                myMember: {
                  signalingId: number;
                };
              };
            };
          }) => {
            if (response?.message === "success") {
              console.log("joined room -->", response);
              dispatch(
                setLiveRoomDetails({
                  roomId: response.data.room.id,
                  zegoRtcToken: response.data.zegoRtcToken,
                  signalingId: response?.data?.room?.myMember.signalingId,
                  onLive,
                })
              );
              resolve(response);
            }
            if (response?.error?.statusCode === 400) {
              dispatch(resetLiveRoomDetails());
              resolve(response);
            }
          }
        );
      } catch (error) {
        console.log(error);
        resolve(undefined);
      }
    });
  };

  const leaveRoom = () => {
    try {
      socket?.emit("fe_leave_room", {}, (response: any) => {
        console.log("leave--->>", response);
        dispatch(resetLiveRoomDetails());
      });
    } catch (error) {
      console.log(error);
    }
  };

  const sendLiveRoomMsg = (
    payload: UserDataType,
    body: string,
    sockets: Socket
  ) => {
    try {
      console.log("sendMsg--->>>", payload._id);
      console.log(socket);
      const userProfilePic = getImageUrl(payload?.profilePic);
      sockets?.emit(
        "fe_send_channel_message",
        {
          message: {
            body: `{\"messageId\":\"${payload?._id}\",\"header\":{\"author\":{\"id\":\"${payload?._id}\",\"signalingId\":\"551\",\"name\":\"${payload?.username}\",\"avatar\":\"${userProfilePic}\",\"avatarEffectId\":\"\",\"bubbleEffectId\":\"\",\"role\":\"owner\"}},\"body\":{\"type\":\"io.chingari.audiorooms.domain.entity.message.Message.Text\",\"content\":\"${body}\"}}`,
            userId: payload?._id,
          },
        },
        (res: unknown) => {
          console.log("-->>>", res);
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  return { joinRoom, leaveRoom, sendLiveRoomMsg };
}
